import {Component, Input} from '@angular/core';

@Component({
  selector: 'leada-button',
  templateUrl: 'leada-button.html',
  styleUrls: ['leada-button.scss'],
})
export class LeadaButtonComponent {

  @Input('icon') public iconName: string;
  @Input('new') public new: boolean = false;

}
